import type { ApiCredentialsProperties } from '@repo/api-gw-sdk';

import { Wizard } from '@/components/wizard/Wizard';

import {
  UpsertApiCredentialsFlow,
  type UpsertApiCredentialsState,
} from './upsertApiCredentialsFlow';

interface UpsertApiCredentialsPanelProps {
  entity: ApiCredentialsProperties;
  onSave: (apiCredentials: ApiCredentialsProperties) => Promise<void>;
  onAbort: () => void;
}

export function ApiCredentialsPanel(props: UpsertApiCredentialsPanelProps) {
  const save = async (state: UpsertApiCredentialsState) => {
    await props.onSave(state);
    return true;
  };

  return (
    <Wizard<UpsertApiCredentialsState>
      hideBackArrow={true}
      onAbort={props.onAbort}
      onFinish={save}
      initialStep={{ stepIndex: props.entity.id ? 1 : 0 }}
      flow={[UpsertApiCredentialsFlow]}
      initialState={{
        ...props.entity,
      }}
      title={props.entity.clientId ? `Edit Credentials` : `Create Credentials`}
    />
  );
}
